import { render, staticRenderFns } from "./Dataview.vue?vue&type=template&id=e1254454&scoped=true&"
import script from "./Dataview.vue?vue&type=script&lang=js&"
export * from "./Dataview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1254454",
  null
  
)

export default component.exports